import React, { useState } from "react";
import { Statistic } from "antd";

const { Countdown: AntCountdown } = Statistic;

interface CountdownProps {
  startTime: string | Date;
  duration: string | number;
}

const Countdown: React.FC<CountdownProps> = ({ startTime, duration }) => {
  const deadline = new Date(startTime).getTime() + parseInt(duration.toString());
  const [color, setColor] = useState(deadline <= Date.now() ? "#CC0029" : "#004FAC");

  if (isNaN(deadline)) {
    return null;
  }
  return (
    <AntCountdown value={deadline} onFinish={() => setColor("#CC0029")} valueStyle={{ color }} />
  );
};

export default Countdown;
